type IUser = {
  firstName?: string;
  lastName?: string;
};

export const getFullName = (user?: IUser): string => {
  if (!user?.firstName && !user?.lastName) return '';
  return `${user?.firstName || ''} ${user?.lastName || ''}`;
};

/**
 * Returns the singular or plural form of a word based on count
 * @param count - The count to check
 * @param singular - The singular form of the word
 * @param plural - Optional plural form. If not provided, defaults to `${singular}s`
 * @returns The singular form if count is 1, otherwise the plural form
 */
export const pluralize = (
  count: number,
  singular: string,
  plural?: string
): string => (count === 1 ? singular : plural ?? `${singular}s`);
